import { Division } from '../types/division'
import { http } from '../services/http'
export const fetchDivisions = async (): Promise<Array<Division>> => {
  const response = await http.get<Array<Division>>('/v2/divisions')
  return response.data
}
